"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_leaflet_1 = require("react-leaflet");
const leaflet_1 = __importDefault(require("leaflet"));
require("leaflet/dist/leaflet.css");
const marker_icon_png_1 = __importDefault(require("leaflet/dist/images/marker-icon.png"));
const marker_shadow_png_1 = __importDefault(require("leaflet/dist/images/marker-shadow.png"));
if (typeof window !== 'undefined') {
    const DefaultIcon = leaflet_1.default.icon({
        iconUrl: marker_icon_png_1.default,
        shadowUrl: marker_shadow_png_1.default,
        iconSize: [25, 40],
        iconAnchor: [12, 40],
    });
    leaflet_1.default.Marker.prototype.options.icon = DefaultIcon;
}
const SetCentre = (props) => {
    const map = react_leaflet_1.useMap();
    react_1.useEffect(() => {
        map.panTo(props.centre);
    }, [props.centre]);
    return null;
};
const Map = (props) => {
    if (typeof window === 'undefined') {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    const { box, centre, pin, zoom } = props;
    const cartoApiKey = process.env.REACT_APP_CARTO_API_KEY || process.env.GATSBY_CARTO_API_KEY;
    const tileUrl = cartoApiKey
        ? `https://basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png?key=${encodeURIComponent(cartoApiKey)}`
        : 'https://basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png';
    let centrePin;
    if (pin && pin.lat && pin.lng) {
        centrePin = pin;
    }
    else if (box && box.northwestBound && box.northeastBound && box.southeastBound && box.southwestBound) {
        centrePin = {
            lat: (box.northwestBound.lat + box.southeastBound.lat) / 2,
            lng: (box.northwestBound.lng + box.southeastBound.lng) / 2,
        };
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_leaflet_1.MapContainer, { style: { height: '100%', width: '100%' }, id: 'mapid', center: centre, zoom: zoom },
            react_1.default.createElement(react_leaflet_1.TileLayer, { attribution: '\u00A9 <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors \u00A9 <a href="https://carto.com/attributions">CARTO</a>', url: tileUrl, subdomains: "abcd", maxZoom: 20 }),
            centrePin && react_1.default.createElement(react_leaflet_1.Marker, { position: centrePin }),
            box && (react_1.default.createElement(react_leaflet_1.Polygon, { pathOptions: { color: 'blue' }, positions: [box.northwestBound, box.northeastBound, box.southeastBound, box.southwestBound] })),
            react_1.default.createElement(SetCentre, { centre: props.centre }))));
};
Map.propTypes = {
    centre: prop_types_1.default.shape({
        lat: prop_types_1.default.number,
        lng: prop_types_1.default.number,
    }).isRequired,
    pin: prop_types_1.default.shape({
        lat: prop_types_1.default.number,
        lng: prop_types_1.default.number,
    }),
    box: prop_types_1.default.shape({
        northwestBound: prop_types_1.default.shape({
            lat: prop_types_1.default.number,
            lng: prop_types_1.default.number,
        }),
        northeastBound: prop_types_1.default.shape({
            lat: prop_types_1.default.number,
            lng: prop_types_1.default.number,
        }),
        southwestBound: prop_types_1.default.shape({
            lat: prop_types_1.default.number,
            lng: prop_types_1.default.number,
        }),
        southeastBound: prop_types_1.default.shape({
            lat: prop_types_1.default.number,
            lng: prop_types_1.default.number,
        }),
    }),
    zoom: prop_types_1.default.number,
};
exports.default = Map;
